import { render, staticRenderFns } from "./Indicadores.vue?vue&type=template&id=182b2d73&scoped=true"
import script from "./Indicadores.vue?vue&type=script&lang=js"
export * from "./Indicadores.vue?vue&type=script&lang=js"
import style0 from "./Indicadores.vue?vue&type=style&index=0&id=182b2d73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182b2d73",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
